import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import ContactForm from '../components/ContactForm';

const ContactPage = () => {
    const contactInfo = [
        {
            icon: "📍",
            title: "Visit Our Headquarters",
            details: [

                "G4I, 446, 3rd Floor",
                "Ubber MEWS Gate, kharar,",
                "Punjab",
                "PIN: 140301",
                "India"
            ]
        },
        {
            icon: "📞",
            title: "Contact Information",
            details: [
                "Phone: 8610788265 / 8920152532",
                "Email: accounts@sifgroup.org",
                "Website: www.sifgroup.org",
                "Hours: Mon-Sun, 6AM-10PM"
            ]
        },
        {
            icon: "🏌️",
            title: "Quick Services",
            details: [
                "General Inquiries: Cmd@sifgroup.org",
                "Academy: accounts@sifgroup.org", 
                /*"Corporate Events: events@golf4i.com",
                "Equipment: shop@golf4i.com"*/
            ]
        }
    ];

    const branches = [
        {
            city: "Kharar",
            address: "G4I, 446, 3rd Floor, Ubber MEWS Gate, Kharar, Mohali – 140301, Punjab, India",
            phone: "+91 86107 88265 / +91 89201 52532",
            email: "accounts@sifgroup.org / Cmd@sifgroup.org"
        },
        /*{
            city: "Delhi",
            address: "Golf4International Headquarters, Bijwasan",
            phone: "011 - 45589523",
            email: "delhi@golf4i.com"
        },
        {
            city: "Mumbai",
            address: "Bandra Kurla Complex, Mumbai",
            phone: "+91 22 6789 1234",
            email: "mumbai@golf4i.com"
        },
        {
            city: "Bengaluru",
            address: "Whitefield, Bengaluru",
            phone: "+91 80 4567 8901",
            email: "bengaluru@golf4i.com"
        }*/
    ];

    const faqItems = [
        {
            question: "What's the best way to contact you for membership inquiries?",
            answer: "For membership inquiries, please use the contact form above or email membership@golf4i.com. You can also visit our facility for a personal tour and consultation."
        },
        {
            question: "Do I need to book appointments for golf lessons in advance?",
            answer: "Yes, we recommend booking golf lessons at least 48 hours in advance to ensure coach availability. You can book through our website, mobile app, or by calling our academy desk."
        },
        {
            question: "What are your corporate event booking procedures?",
            answer: "Corporate events require advance booking. Please contact our events team at events@golf4i.com with your requirements, preferred dates, and group size. We'll provide a customized proposal within 24 hours."
        },
        {
            question: "Can I visit your facility without an appointment?",
            answer: "Yes, our facility is open for walk-in visits during operating hours. However, for personalized tours or specific service consultations, we recommend scheduling an appointment."
        },
        {
            question: "How do I get updates about upcoming tournaments and events?",
            answer: "Subscribe to our newsletter through the form below to receive regular updates about tournaments, events, and special offers. You can also follow us on social media for real-time updates."
        },
        {
            question: "What payment methods do you accept?",
            answer: "We accept all major credit/debit cards, UPI payments, net banking, and cash. Corporate bookings can be made through bank transfers with proper documentation."
        },
        {
            question: "Do you offer beginner golf programs?",
            answer: "Absolutely! We have specialized beginner programs that include equipment, basic training, and gradual skill development. Our certified instructors ensure a comfortable learning experience for all beginners."
        },
        {
            question: "What safety measures are in place at your facilities?",
            answer: "We maintain the highest safety standards with regular equipment inspections, certified instructors, emergency protocols, and clean, well-maintained facilities to ensure a safe golfing experience."
        }
    ];

    return (
        <>
            {/* Hero Section - Standardized with other pages */}
            <section className="contact-hero-section">
                <div className="hero-overlay"></div>
                <div className="hero-pattern"></div>

                <Container className="position-relative z-3 h-100">
                    <Row className="h-100 align-items-center justify-content-center">
                        <Col xs={12} lg={10} xl={8} className="text-center text-white">
                            <h1 className="hero-title mb-4">Contact Us</h1>
                            <p className="hero-subtitle mb-5">
                                Get in touch with our golf experts. We're here to help you elevate your game.
                            </p>
                            <div className="hero-cta d-flex flex-column flex-sm-row justify-content-center gap-3">
                                <a href="#contact-form" className="btn btn-gold-filled btn-lg px-4 px-md-5 py-3">
                                    Send Message
                                </a>
                                <a href="#branches" className="btn btn-gold btn-lg px-4 px-md-5 py-3">
                                    Our Branches
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Information Section */}
            <section className="section-padding">
                <Container>
                    <Row className="mb-5">
                        <Col xs={12} className="text-center">
                            <h2 className="section-title mb-3">Get in Touch</h2>
                            <p className="section-subtitle">
                                Have questions about our services, membership, or facilities? Our team is ready to assist you.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4 mb-5 justify-content-center">
                        {contactInfo.map((info, index) => (
                            <Col xs={12} md={6} lg={4} key={index}>
                                <div className="contact-info-card card-modern h-100 p-3 p-md-4 text-center">
                                    <div className="contact-icon mb-3">
                                        {info.icon}
                                    </div>
                                    <h3 className="h5 mb-3 text-green">{info.title}</h3>
                                    <ul className="contact-details">
                                        {info.details.map((detail, idx) => (
                                            <li key={idx} className="mb-2">{detail}</li>
                                        ))}
                                    </ul>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <Row className="g-4 g-lg-5">
                        <Col lg={6}>
                            <div className="mb-5">
                                <h3 className="h4 mb-3 text-green">Send Us a Message</h3>
                                <p className="contact-description mb-4">
                                    Fill out the form below and one of our golf professionals will get back to you within 24 hours.
                                    Whether you're interested in lessons, membership, or corporate events, we're here to help.
                                </p>

                                <div className="mb-4">
                                    <h4 className="h5 mb-3 text-gold">Response Time</h4>
                                    <ul className="response-time">
                                        <li className="mb-2">General Inquiries: Within 24 hours</li>
                                        <li className="mb-2">Membership Applications: Within 48 hours</li>
                                        <li className="mb-2">Event Bookings: Within 12 hours</li>
                                        <li className="mb-0">Urgent Matters: Call us directly</li>
                                    </ul>
                                </div>
                            </div>

                            {
                            <div id="branches">
                                <h4 className="h5 mb-3 text-green">Our Branches</h4>
                                <Row className="g-3">
                                    {branches.map((branch, index) => (
                                        <Col xs={12} key={index}>
                                            <div className="branch-card card-modern p-3 p-md-4 h-100">
                                                <h5 className="h6 mb-2 text-gold">{branch.city}</h5>
                                                <p className="branch-address small mb-1">{branch.address}</p>
                                                <p className="branch-phone small mb-1">{branch.phone}</p>
                                                <p className="branch-email small mb-0">{branch.email}</p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                            }
                        </Col>

                        <Col lg={6}>
                            <div id="contact-form" className="contact-form-wrapper">
                                <ContactForm />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Map and Directions Section with Google Maps */}
            <section className="section-padding bg-soft-sage">
                <Container>
                    <Row className="mb-5">
                        <Col xs={12} className="text-center">
                            <h2 className="section-title mb-3">Find Us</h2>
                            <p className="section-subtitle">
                                Visit our flagship facility in Delhi or explore our other locations across India.
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-4 g-lg-5 align-items-center">
                        <Col lg={6}>
                            <div className="map-container rounded overflow-hidden">
                                <div className="map-label">
                                    <div className="map-label-left">
                                        <strong>Kharar</strong>
                                        <div className="map-sub">Punjab</div>
                                    </div>

                                    <a
                                        href="https://www.google.com/maps/dir/?api=1&destination=28.534146,77.058620"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="map-direction-icon"
                                    >
                                        <i className="fas fa-directions"></i>
                                    </a>
                                </div>
                                <div className="map-overlay d-flex align-items-center justify-content-center">
                                    <div className="map-overlay-content text-center">
                                        <div className="map-icon mb-3">
                                            🏌️
                                        </div>
                                        <h4 className="h5 mb-2">Golf4International Headquarters</h4>
                                        <p className="small mb-0">
                                            Click the button below to open in Google Maps
                                        </p>
                                    </div>
                                </div>
                                <iframe
                                    src="https://www.google.com/maps?q=30.760943,76.6324409&output=embed"
                                    width="100%"
                                    height="400"
                                    style={{ border: 0, display: 'block' }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Golf4International Headquarters Location"
                                    className="map-iframe"
                                ></iframe>
                            </div>

                            <div className="mt-3 text-center">
                                <a
                                    href="https://www.google.com/maps/place/30%C2%B045'39.4%22N+76%C2%B037'56.8%22E/@30.760943,76.629866,17z/data=!3m1!4b1!4m4!3m3!8m2!3d30.760943!4d76.6324409?hl=en&entry=ttu&g_ep=EgoyMDI2MDkwMi4wIKXMDSoASAFQAw%3D%3D"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-gold btn-sm"
                                >
                                    <i className="fas fa-external-link-alt me-2"></i>
                                    Open in Google Maps
                                </a>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="directions-card card-modern p-3 p-md-4">
                                <h3 className="h4 mb-3 text-green">Directions & Parking</h3>

                                <div className="mb-4">
                                    <h5 className="h6 mb-2 text-gold">By Train</h5>
                                    <p className="small mb-0">
                                       Nearest Railway Station: Kharar Railway Station
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 className="h6 mb-2 text-gold">By Road</h5>
                                    <p className="small mb-0">
                                        The facility is easily accessible via NH-21 / Kharar–Kurali Road
                                    </p>
                                </div>

                                <div className="mb-4">
                                    <h5 className="h6 mb-2 text-gold">Parking</h5>
                                    <p className="small mb-0">
                                        Parking available at Ubber Mews Gate
                                    </p>
                                </div>

                                <div>
                                    <h5 className="h6 mb-2 text-gold">Facility Hours</h5>
                                    <p className="small mb-0">
                                        Monday - Sunday: 6:00 AM - 10:00 PM
                                        <br />
                                        Last Entry: 9:00 PM
                                        <br />
                                        Special Events: Extended hours available
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Enhanced FAQ Section */}
            <section className="section-padding">
                <Container>
                    <Row className="mb-5">
                        <Col xs={12} className="text-center">
                            <h2 className="section-title mb-3">Frequently Asked Questions</h2>
                            <p className="section-subtitle">
                                Quick answers to common questions about contacting us and our services.
                            </p>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col xs={12} lg={10} xl={8}>
                            <div className="faq-accordion card-modern p-3 p-md-4">
                                <div className="faq-header text-center mb-4">
                                    <div className="faq-icon mb-3">
                                        ❓
                                    </div>
                                    <h3 className="h4 text-green">Common Questions</h3>
                                    <p className="text-muted mb-0">
                                        Click on any question below to reveal the answer
                                    </p>
                                </div>

                                <Accordion flush className="faq-list">
                                    {faqItems.map((faq, index) => (
                                        <Accordion.Item
                                            eventKey={index.toString()}
                                            key={index}
                                            className="faq-item border-0 mb-2"
                                        >
                                            <Accordion.Header className="faq-question px-3 py-3">
                                                <div className="faq-question-content d-flex align-items-center">
                                                    <div className="faq-number me-3">
                                                        {index + 1}
                                                    </div>
                                                    <span className="faq-question-text">{faq.question}</span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body className="faq-answer px-3 py-3">
                                                <div className="faq-answer-content d-flex">
                                                    <div className="faq-answer-icon me-3">
                                                        💡
                                                    </div>
                                                    <div>
                                                        <p className="mb-0">{faq.answer}</p>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>

                                <div className="faq-footer text-center mt-4 pt-3 border-top">
                                    <p className="text-muted mb-3">
                                        Still have questions? Contact us directly for personalized assistance.
                                    </p>
                                    <a href="#contact-form" className="btn btn-gold">
                                        Ask Your Question
                                    </a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* CSS Styles */}
            <style jsx>{`
                /* Hero Section - Standardized with other pages */
                .contact-hero-section {
                    height: 70vh;
                    min-height: 600px;
                    background: linear-gradient(rgba(31, 61, 43, 0.6), rgba(31, 61, 43, 0.75)), 
                               url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQs-qcBxTIuK3F5HC0z3Oru8pQFeihe-qz8hQ&s') center/cover no-repeat;
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    padding-top: 80px;
                }
                
                .hero-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(180deg, rgba(31, 61, 43, 0.5) 0%, rgba(31, 61, 43, 0.7) 100%);
                    z-index: 1;
                }
                
                .hero-pattern {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(circle at center, rgba(181, 154, 90, 0.1) 0%, transparent 70%);
                    animation: pulse 4s ease-in-out infinite;
                    z-index: 1;
                }
                
                .hero-title {
                    font-size: clamp(2rem, 5vw, 3.5rem);
                    color: #B59A5A;
                    font-weight: 600;
                    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
                    position: relative;
                    z-index: 2;
                    line-height: 1.2;
                    margin-bottom: 1.5rem;
                    font-family: 'Playfair Display', serif;
                }
                
                .hero-subtitle {
                    font-size: clamp(1rem, 2.5vw, 1.5rem);
                    line-height: 1.6;
                    color: rgba(255, 255, 255, 0.95);
                    text-shadow: 0 1px 3px rgba(0,0,0,0.3);
                    position: relative;
                    z-index: 2;
                    margin-bottom: 2.5rem;
                    max-width: 800px;
                    margin-left: auto;
                    margin-right: auto;
                    font-weight: 400;
                }
                
                .hero-cta {
                    position: relative;
                    z-index: 2;
                }
                
                /* Button Styles - Consistent with other pages */
                .btn-gold-filled {
                    background-color: #B59A5A;
                    color: #1F3D2B;
                    border: none;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    padding: 12px 24px;
                    border-radius: 8px;
                    font-size: 1rem;
                    white-space: nowrap;
                }
                
                .btn-gold-filled:hover {
                    background-color: #d4b56e;
                    color: #1F3D2B;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0,0,0,0.15);
                }
                
                .btn-gold {
                    background-color: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(5px);
                    color: #B59A5A;
                    border: 2px solid #B59A5A;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    padding: 12px 24px;
                    border-radius: 8px;
                    font-size: 1rem;
                    white-space: nowrap;
                }
                
                .btn-gold:hover {
                    background-color: rgba(181, 154, 90, 0.2);
                    color: #d4b56e;
                    border-color: #d4b56e;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0,0,0,0.15);
                }
                
                /* Section Styles */
                .section-padding {
                    padding: clamp(3rem, 6vw, 5rem) 0;
                }
                
                .section-title {
                    font-size: clamp(1.75rem, 4vw, 2.5rem);
                    color: #1F3D2B;
                    font-weight: 600;
                    margin-bottom: 1rem;
                    line-height: 1.2;
                    font-family: 'Playfair Display', serif;
                }
                
                .section-subtitle {
                    color: #666;
                    font-size: clamp(0.9rem, 1.5vw, 1.1rem);
                    line-height: 1.6;
                    max-width: 700px;
                    margin-left: auto;
                    margin-right: auto;
                    font-weight: 400;
                }
                
                /* Contact Info Cards */
                .contact-info-card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    height: 100%;
                    text-align: center;
                }
                
                .contact-info-card:hover {
                    transform: translateY(-5px);
                }
                
                .contact-icon {
                    width: clamp(50px, 8vw, 60px);
                    height: clamp(50px, 8vw, 60px);
                    background-color: #f0f7f3;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: clamp(1.5rem, 3vw, 2rem);
                    margin: 0 auto 1rem;
                }
                
                .contact-details {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                
                .contact-details li {
                    color: #666;
                    font-size: clamp(0.9rem, 1.5vw, 1rem);
                    line-height: 1.5;
                }
                
                /* Contact Description */
                .contact-description {
                    color: #666;
                    font-size: clamp(0.95rem, 1.5vw, 1.05rem);
                    line-height: 1.6;
                }
                
                /* Response Time List */
                .response-time {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                
                .response-time li {
                    color: #666;
                    font-size: clamp(0.9rem, 1.5vw, 1rem);
                    line-height: 1.5;
                }
                
                /* Branch Cards */
                .branch-card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                
                .branch-card:hover {
                    transform: translateY(-3px);
                }
                
                .branch-address,
                .branch-phone,
                .branch-email {
                    color: #666;
                    line-height: 1.4;
                }
                
                /* Google Maps Container */
                .map-container {
                    position: relative;
                    height: 400px;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                }
                
                .map-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(31, 61, 43, 0.8);
                    z-index: 10;
                    transition: opacity 0.3s ease;
                    opacity: 1;
                     pointer-events: none;
                }
                
                .map-container:hover .map-overlay {
                    opacity: 0;
                }
                
                .map-overlay-content {
                    padding: 2rem;
                    color: white;
                    max-width: 300px;
                }
                
                .map-icon {
                    font-size: 3rem;
                    animation: bounce 2s infinite;
                }
                
                .map-iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: none;
                }
                
                /* Directions Card */
                .directions-card {
                    height: 100%;
                }
                
                .directions-card p {
                    color: #666;
                    line-height: 1.5;
                }
                
                /* Enhanced FAQ Section */
                .faq-accordion {
                    border-radius: 12px;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
                }
                
                .faq-header {
                    padding: 1rem 0;
                }
                
                .faq-icon {
                    width: 60px;
                    height: 60px;
                    background-color: #f0f7f3;
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.8rem;
                    margin: 0 auto;
                }
                
                .faq-list {
                    background: transparent;
                }
                
                .faq-item {
                    margin-bottom: 0.5rem;
                    border-radius: 8px;
                    overflow: hidden;
                    background: #f8f9fa;
                    transition: all 0.3s ease;
                }
                
                .faq-item:hover {
                    background: #f0f7f3;
                }
                
                .faq-question {
                    background: transparent !important;
                    border: none !important;
                    box-shadow: none !important;
                    padding: 1rem 1.5rem;
                    color: #1F3D2B !important;
                    font-weight: 600;
                    font-size: clamp(0.95rem, 1.5vw, 1rem);
                    transition: all 0.3s ease;
                }
                
                .faq-question:not(.collapsed) {
                    color: #B59A5A !important;
                }
                
                .faq-question::after {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%231F3D2B'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                    transform: rotate(-90deg);
                    transition: transform 0.3s ease;
                }
                
                .faq-question:not(.collapsed)::after {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23B59A5A'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                    transform: rotate(0deg);
                }
                
                .faq-question-content {
                    width: 100%;
                }
                
                .faq-number {
                    width: 30px;
                    height: 30px;
                    background-color: #B59A5A;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.9rem;
                    font-weight: 600;
                    flex-shrink: 0;
                }
                
                .faq-question-text {
                    flex: 1;
                    line-height: 1.4;
                }
                
                .faq-answer {
                    background: #f8f9fa;
                    border-top: 1px solid rgba(31, 61, 43, 0.1);
                    color: #666;
                    font-size: clamp(0.9rem, 1.5vw, 1rem);
                    line-height: 1.6;
                }
                
                .faq-answer-content {
                    align-items: flex-start;
                }
                
                .faq-answer-icon {
                    width: 30px;
                    height: 30px;
                    background-color: #f0f7f3;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1rem;
                    color: #B59A5A;
                    flex-shrink: 0;
                    margin-top: 2px;
                }
                
                .faq-footer {
                    border-top: 1px solid rgba(31, 61, 43, 0.1);
                }
                
                /* Newsletter Card - Consistent with other pages */
                .newsletter-card {
                    background: linear-gradient(135deg, #1F3D2B 0%, #2a4d3b 100%);
                    color: white;
                    padding: clamp(2rem, 4vw, 3rem);
                    border-radius: 15px;
                    width: 100%;
                }
                
                .newsletter-icon {
                    width: clamp(60px, 10vw, 80px);
                    height: clamp(60px, 10vw, 80px);
                    background-color: rgba(255, 255, 255, 0.2);
                    border-radius: 50%;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: clamp(1.5rem, 3vw, 2rem);
                    margin: 0 auto 1.5rem;
                }
                
                .newsletter-text {
                    opacity: 0.9;
                    font-size: clamp(0.9rem, 1.5vw, 1.1rem);
                    line-height: 1.6;
                    margin-bottom: 2rem;
                    font-weight: 400;
                }
                
                .newsletter-form {
                    margin-bottom: 1rem;
                }
                
                .newsletter-input-wrapper {
                    max-width: 500px;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: row;
                    gap: 0;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                }
                
                .newsletter-email-input {
                    flex: 1;
                    padding: clamp(12px, 2vw, 15px) clamp(15px, 2vw, 20px);
                    border: none;
                    font-size: clamp(0.9rem, 1.5vw, 1rem);
                    background: #ffffff;
                    color: #333333;
                    min-width: 0;
                    outline: none;
                    font-family: inherit;
                    line-height: 1.5;
                    font-weight: 400;
                }
                
                .newsletter-email-input::placeholder {
                    color: #666666 !important;
                    opacity: 0.8 !important;
                    font-weight: 400;
                }
                
                .newsletter-email-input:focus {
                    background: #ffffff;
                    box-shadow: none;
                }
                
                .newsletter-subscribe-btn {
                    border: none;
                    padding: clamp(12px, 2vw, 15px) clamp(20px, 3vw, 32px);
                    font-weight: 600;
                    font-size: clamp(0.9rem, 1.5vw, 1rem);
                    white-space: nowrap;
                    background-color: #B59A5A;
                    color: #FFFFFF;
                    transition: all 0.3s ease;
                    cursor: pointer;
                    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
                    font-family: inherit;
                    line-height: 1.5;
                    text-align: center;
                    text-decoration: none;
                    user-select: none;
                    display: inline-block;
                    border-left: 1px solid rgba(0,0,0,0.1);
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }
                
                .newsletter-subscribe-btn:hover {
                    background-color: #d4b56e;
                    color: #FFFFFF;
                }
                
                .newsletter-terms {
                    opacity: 0.7;
                    font-size: clamp(0.75rem, 1.2vw, 0.85rem);
                    font-weight: 300;
                }
                
                /* Text Colors */
                .text-gold {
                    color: #B59A5A;
                }
                
                .text-green {
                    color: #1F3D2B;
                }
                
                .text-muted {
                    color: #666;
                }
                
                /* Background Colors */
                .bg-soft-sage {
                    background-color: #f0f7f3;
                }
                
                /* Animations */
                @keyframes pulse {
                    0%, 100% {
                        opacity: 0.1;
                    }
                    50% {
                        opacity: 0.2;
                    }
                }
                
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes bounce {
                    0%, 20%, 50%, 80%, 100% {
                        transform: translateY(0);
                    }
                    40% {
                        transform: translateY(-10px);
                    }
                    60% {
                        transform: translateY(-5px);
                    }
                }
                
                /* Responsive Button Sizes */
                .btn-lg {
                    padding: clamp(10px, 2vw, 12px) clamp(20px, 3vw, 32px);
                    font-size: clamp(0.9rem, 1.5vw, 1rem);
                }
                
                /* Responsive Grid Gaps */
                .g-4 {
                    --bs-gutter-x: clamp(1rem, 2vw, 1.5rem);
                    --bs-gutter-y: clamp(1rem, 2vw, 1.5rem);
                }
                
                .g-5 {
                    --bs-gutter-x: clamp(1.5rem, 3vw, 2rem);
                    --bs-gutter-y: clamp(1.5rem, 3vw, 2rem);
                }
                
                /* ================= MOBILE RESPONSIVE FIXES ================= */
                
                /* Extra Small Devices - Mobile Phones */
                @media (max-width: 576px) {
                    .contact-hero-section {
                        height: 65vh;
                        min-height: 500px;
                        padding-top: 100px;
                    }
                    
                    .hero-title {
                        margin-bottom: 1rem;
                        font-size: 2.2rem;
                    }
                    
                    .hero-subtitle {
                        margin-bottom: 2rem;
                        font-size: 1.1rem;
                    }
                    
                    .hero-cta {
                        flex-direction: column;
                        gap: 1rem;
                        margin-top: 20px;
                    }
                    
                    .hero-cta .btn {
                        width: 100%;
                        padding: 14px 20px;
                        font-size: 1rem;
                    }
                    
                    .contact-icon {
                        width: 50px;
                        height: 50px;
                        font-size: 1.5rem;
                    }
                    
                    .map-container {
                        height: 300px;
                    }
                    
                    .map-overlay-content {
                        padding: 1rem;
                    }
                    
                    .map-icon {
                        font-size: 2rem;
                    }
                    
                    .faq-question {
                        padding: 0.75rem 1rem;
                    }
                    
                    .faq-number {
                        width: 25px;
                        height: 25px;
                        font-size: 0.8rem;
                        margin-right: 0.75rem;
                    }
                    
                    .faq-answer-icon {
                        width: 25px;
                        height: 25px;
                        font-size: 0.9rem;
                        margin-right: 0.75rem;
                    }
                    
                    .newsletter-input-wrapper {
                        flex-direction: column;
                        gap: 1rem;
                        border-radius: 8px;
                        overflow: visible;
                        box-shadow: none;
                        max-width: 100%;
                    }
                    
                    .newsletter-email-input {
                        width: 100%;
                        border-radius: 8px;
                        padding: 14px 20px;
                        font-size: 1rem;
                        background: #ffffff !important;
                        border: 1px solid rgba(255, 255, 255, 0.2);
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                        color: #333333 !important;
                    }
                    
                    .newsletter-email-input::placeholder {
                        color: #666666 !important;
                        opacity: 0.8 !important;
                        font-size: 0.95rem;
                        font-weight: 400;
                    }
                    
                    .newsletter-subscribe-btn {
                        width: 100%;
                        border-radius: 8px;
                        padding: 14px 20px;
                        font-size: 1rem;
                        border-left: none;
                        box-shadow: 0 4px 12px rgba(181, 154, 90, 0.2);
                    }
                    
                    .btn-lg {
                        padding: 14px 20px;
                    }
                }
                
                /* Small Devices - Larger Mobile Phones */
                @media (min-width: 577px) and (max-width: 768px) {
                    .contact-hero-section {
                        height: 70vh;
                        min-height: 550px;
                        padding-top: 90px;
                    }
                    
                    .hero-title {
                        font-size: 2.8rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 1.3rem;
                    }
                    
                    .hero-cta {
                        margin-top: 10px;
                    }
                    
                    .map-container {
                        height: 350px;
                    }
                }
                
                /* Medium Devices - Tablets */
                @media (min-width: 769px) and (max-width: 992px) {
                    .contact-hero-section {
                        height: 75vh;
                        min-height: 600px;
                        padding-top: 80px;
                    }
                    
                    .map-container {
                        height: 400px;
                    }
                }
                
                /* Large Devices - Desktops */
                @media (min-width: 993px) and (max-width: 1199px) {
                    .contact-hero-section {
                        height: 80vh;
                        min-height: 650px;
                        padding-top: 60px;
                    }
                    
                    .map-container {
                        height: 400px;
                    }
                }
                
                /* Very Large Screens */
                @media (min-width: 1200px) {
                    .contact-hero-section {
                        height: 85vh;
                        min-height: 700px;
                        padding-top: 40px;
                    }
                    
                    .map-container {
                        height: 400px;
                    }
                }
                
                /* Landscape Orientation on Mobile */
                @media (max-height: 600px) and (orientation: landscape) {
                    .contact-hero-section {
                        height: 100vh;
                        min-height: 400px;
                        padding-top: 80px;
                    }
                    
                    .hero-title {
                        font-size: 2rem;
                        margin-bottom: 0.5rem;
                    }
                    
                    .hero-subtitle {
                        font-size: 1rem;
                        margin-bottom: 1.5rem;
                    }
                    
                    .map-container {
                        height: 250px;
                    }
                }
                
                /* Accessibility: Focus states */
                button:focus,
                input:focus,
                a:focus {
                    outline: 2px solid #B59A5A;
                    outline-offset: 2px;
                }
                
                /* Print styles */
                @media print {
                    .hero-cta,
                    .newsletter-card,
                    .contact-form-wrapper {
                        display: none !important;
                    }
                    
                    .contact-hero-section {
                        padding-top: 0;
                        height: auto;
                        min-height: auto;
                    }
                }
                    .map-label {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 5;

  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #fff;
  border-radius: 8px;

  padding: 8px 10px;
  min-width: 200px;

  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  border: 1px solid #dadce0;
}

.map-label-left strong {
  font-size: 13px;
  color: #202124;
  font-weight: 600;
}

.map-sub {
  font-size: 11px;
  color: #5f6368;
}

.map-direction-icon {
  margin-left: 10px;

  /* outer grey container */
  background: #f1f3f4;
  border: 1px solid #dadce0;

  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 6px;
  text-decoration: none;

  /* smooth look */
  transition: all 0.2s ease;
}

.map-direction-icon i {
  color: #1a73e8; /* Google blue */
  font-size: 16px;
}

.map-direction-icon:hover {
  background: #e8eaed; /* light grey hover */
}
            `}</style>
        </>
    );
};

export default ContactPage;